module.exports = __webpack_public_path__ + "static/media/sacha.1dd5de7d.jpg";